import { ACCOUNT_CONTEXT } from "fond/constants";
import { getItem, setItem } from "fond/utils/localStorage";

type AccountContext = Record<string, string>;

/**
 * Get the raw account context object or an empty object
 *
 * @returns the existing account context or an empty object
 */
const getRawAccountContext = (): AccountContext => {
  const context = getItem(ACCOUNT_CONTEXT);
  if (!context) {
    return {};
  }
  return context;
};

/**
 * Get the account context for a given user.
 *
 * @param userId - the user ID to retrieve the currently selected account for
 * @returns the user account ID
 */
export const getAccountContext = (userId?: string): string | undefined => {
  const context = getRawAccountContext();
  if (!userId) {
    return undefined;
  }

  return context?.[userId];
};

/**
 * Set the account context to a given account ID for a user.
 *
 * @param userId - the user ID to set the account context for
 * @param accountId - the account ID to set the context to
 */
export const setAccountContext = (userId: string, accountId: string) => {
  if (!userId) {
    throw new Error("Could not set account context. Missing user ID.");
  }
  if (!accountId) {
    throw new Error("Could not set account context. Missing account ID.");
  }
  const context = getRawAccountContext();
  setItem(ACCOUNT_CONTEXT, { ...context, [userId]: accountId });
};
